import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stepShipmentFulfilled, stepTypeFulfilled } from '../../actions/registerShipmentActions';
import { getCurrentLangPretty } from '../../helpers/url/urlHelpers';
import { mapWeightToCategory, snapWeightToCategory } from '../registerShipment/registerShipmentForm/stepShipment/stepShipmentForm/helpers/weightCategoryMapper';
import ISettingsViewModel from '../../interfaces/umbracoNodes/settingsViewModel';
import SafeRedirect from '../safeRedirect';
import CalcForm from './calcForm';
import {
	registerShipmentCalculatorInitialValues,
	RegisterShipmentCalculatorSchema,
} from './registerShipmentCalculator.schema';
import * as StyledRegisterShipmentCalculator from './registerShipmentCalculator.styles';

interface Props {
	country?: string;
}

const RegisterShipmentCalculator: FC<Props> = ({ country }) => {
	const dispatch = useDispatch<any>();
	const [submitted, setSubmitted] = useState(false);
	const { settings }: { settings: ISettingsViewModel } = useSelector(
		(state: { pageReducer: { settings: ISettingsViewModel } }) => state.pageReducer
	);

	const onCalcSubmit = values => {
		const countryCode = values.country?.value || 'IS';
		const weightCategory = mapWeightToCategory(values.parcelWeight, values.service, countryCode);
		const parcelWeight = snapWeightToCategory(values.parcelWeight, values.service, countryCode);
		dispatch(stepTypeFulfilled(values));
		dispatch(stepShipmentFulfilled({ ...values, weightCategory, parcelWeight }));
		setSubmitted(true);
	};

	if (submitted) return <SafeRedirect to={`${settings.Values.RegisterShipmentLink.Url}`} />;

	const initialValues = registerShipmentCalculatorInitialValues;
	if (country && country === 'GB') {
		initialValues.country.label = getCurrentLangPretty() === 'en' ? 'United Kingdom' : 'Bretland';
		initialValues.country.value = 'GB';
	}

	return (
		<StyledRegisterShipmentCalculator.Wrapper>
			<Formik
				initialValues={initialValues}
				enableReinitialize
				validationSchema={RegisterShipmentCalculatorSchema}
				onSubmit={onCalcSubmit}>
				{({ values, setFieldTouched, setFieldValue, isValid, isSubmitting, errors }) => (
					<CalcForm
						values={values}
						errors={errors}
						setFieldTouched={setFieldTouched}
						setFieldValue={setFieldValue}
						isValid={isValid}
						isSubmitting={isSubmitting}
					/>
				)}
			</Formik>
		</StyledRegisterShipmentCalculator.Wrapper>
	);
};

export default RegisterShipmentCalculator;
